import React from "react";
import "../../css/store.css";
import PropTypes from "prop-types";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
import { ClipLoader } from "react-spinners";
import { SpiceDetails, DhoopDetails, Misc } from "../../Constants/productListConstant";
import Link from "gatsby-link";
import { connect } from "react-redux";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import RestrictedStateWiseComponent from "../../components/RestrictedStateWiseComponent";
import ReactPixel from "react-facebook-pixel";
import ProductStoreCard from "../../components/ProductStoreCard";
// import { push } from "react-router-redux"
// import qs from "qs"
// import Heading from "components/Heading"
import { DropdownButton, MenuItem, ButtonToolbar, Button } from "react-bootstrap";

let settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};
let duration = 300;
// export class ProductStoreCard extends React.Component {
// 	constructor (args) {
// 		super(args)
// 		const { product } = this.props
// 		this.state = {
// 			qty: product.qty || 1,
// 			added: product.qty > 0,
// 			lastCounter: 30,
// 		}
// 	}
// 	componentDidMount () {
// 		const { location } = this.props
// 		ReactPixel.init("145006083100066")
// 		ReactPixel.track("ViewContent", location)
// 	}
// 	componentWillReceiveProps (nextProps) {
// 		// this.setState({
// 		// 	isLoading: true
// 		// })
// 		// console.log("nextProps", nextProps)
// 		if (nextProps.product.qty !== this.props.product.qty) {
// 			const { product } = nextProps
// 			this.state = {
// 				qty: product.qty || 1,
// 				added: product.qty > 0
// 			}
// 		}
// 	}
// 	handleQuantity = (fn) => {
// 		let { qty } = this.state
// 		if (fn === "add") {
// 			this.setState({
// 				qty: qty + 1,
// 				added: false
// 			})
// 		} else {
// 			if (qty - 1 > 0) {
// 				this.setState({
// 					qty: qty - 1,
// 					added: false
// 				})
// 			}
// 		}
// 	}
// 	addToCart = () => {
// 		const { product, setToCart } = this.props
// 		const { qty } = this.state
// 		// window.localStorage.setItem("cart", {})
// 		let cart = JSON.parse(localStorage.getItem("cart"))
// 		let addedProduct = {
// 			...product,
// 			qty: qty
// 		}
// 		if (!cart) {
// 			cart = {
// 				products: {},
// 				totalNumber: 0
// 			}
// 		}
// 		let totalNumber = 1
// 		let bucket = {
// 			products: {
// 				...cart.products,
// 				[addedProduct.id]: addedProduct
// 			},
// 			totalNumber: totalNumber
// 		}
// 		// Object.keys(cart.products).map((key) => {
// 		// 	totalNumber = totalNumber + cart.products[key].qty
// 		// })
// 		// let bucket = cart ? (cart.products || {}) : {}
// 		// console.log("cart", cart)
// 		this.setState({
// 			added: true
// 		})
// 		ReactPixel.track("AddToCart", cart)
// 		localStorage.setItem("cart", JSON.stringify(bucket))
// 		setToCart(bucket)
// 		// var retrievedObject = localStorage.getItem("cart")
// 		// console.log("cart", JSON.parse(retrievedObject))
// 	}
// 	render () {
// 		const { product, region } = this.props
// 		const { qty, added } = this.state
// 		return (
// 			<div className="card">
// 				<div className="slider__content">
// 					<Slider {...settings}>
// 						{product.imgUrls.map((item, i) => {
// 							return (
// 								<div key={i} className="slider__img">
// 									<img src={item} alt={product.productName} className="img img-responsive" />
// 								</div>
// 							)
// 						})}
// 					</Slider>
// 				</div>
// 				<div className="media" style={{ margin: "0" }}>
// 					<Link to={`/products/Detail?${product.type}&${product.urlName.replace(/ /g, "-")}`}>
// 						<div className="card__title">
// 							{product.productName}
// 						</div>
// 					</Link>
// 				</div>
// 				<div className="row">
// 					<div className="col-xs-5" style={{ textAlign: "left" }}>
// 						<div className="card__qty">
// 							Weight
// 						</div>
// 						<div className="card__wt">{product.netWeight}</div>
// 					</div>
// 					<div className="col-xs-5 pull-right" style={{ textAlign: "right" }}>
// 						<div className="card__qty">
// 							Price
// 						</div>
// 						<div className="card__price"><i className="fa fa-inr" aria-hidden="true" /> {product.mrp}</div>
// 					</div>
// 				</div>
// 				{product.type !== "Dhoop" ? <RestrictedStateWiseComponent regionName={region}>
// 					<div className="row" style={{ marginTop: "10px" }}>
// 						<div className="col-xs-4 col-md-6">
// 							<div className="input-group qty">
// 								<span className="input-group-btn">
// 									<button onClick={() => this.handleQuantity("sub")} type="button" className="quantity-left-minus btn btn-default btn-number" data-type="minus" data-field="">
// 										<span className="glyphicon glyphicon-minus" />
// 									</button>
// 								</span>
// 								<input readOnly type="text" id="quantity" name="quantity" className="form-control input-number" value={qty} min="1" max="100" />
// 								<span className="input-group-btn">
// 									<button onClick={() => this.handleQuantity("add")} type="button" className="quantity-right-plus btn btn-default btn-number" data-type="plus" data-field="">
// 										<span className="glyphicon glyphicon-plus" />
// 									</button>
// 								</span>
// 							</div>
// 						</div>
// 						<div className="col-xs-4 col-md-6">
// 							<div className="card__btn">
// 								{qty > 0 && added
// 									? <Button>Added</Button>
// 									: <Button onClick={() => this.addToCart(product)}>Add To Cart</Button>
// 								}
// 							</div>
// 						</div>
// 					</div>
// 				</RestrictedStateWiseComponent> : null}
// 			</div>
// 		)
// 	}
// }

// ProductStoreCard.propTypes = {
// 	product: PropTypes.object,
// 	setToCart: PropTypes.func,
// 	isCartChange: PropTypes.bool
// }

// const mapStateToPropsView = (state, ownProps) => {
// 	const { product } = ownProps
// 	return {
// 		...ownProps,
// 		product: state.addToCartList.products[product.id] || product,
// 		region: state.ipData.region || "delhi",
// 		isCartChange: state.addToCartList.isAddToCartChange,
// 		// region: "XYX"
// 	}
// }

// const mapDispatchToPropsView = dispatch => {
// 	return {
// 		setToCart: (bucket) => dispatch({ type: `SET_TO_CART`, addToCartList: bucket })
// 	}
// }

// const ProductStoreCardWrapper = connect(
// 	mapStateToPropsView,
// 	mapDispatchToPropsView
// )(ProductStoreCard)

const DropdownMenu = ({ title, items, handleSortBy }) => {
  return (
    <DropdownButton id={title} bsStyle="Sort By:" title={`${title}`}>
      {items.map((item, i) => {
        return (
          <MenuItem onClick={() => handleSortBy(item.identifier)} active={title === item.name} key={i} eventKey={i}>
            {item.name}
          </MenuItem>
        );
      })}
    </DropdownButton>
  );
};

DropdownMenu.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
  handleSortBy: PropTypes.func,
};

const SimpleDropdownMenu = ({ title, items, handleChip, activeChip }) => {
  return (
    <DropdownButton id={title} bsStyle="default" title={title}>
      {items.map((item, i) => {
        return (
          <div className="active__chips" key={i}>
            <div className={`prim__tabs chip${item.identifier === activeChip ? "-active" : ""}`} onClick={() => handleChip(item.identifier)} key={i}>
              {item.title}
            </div>
            {item.subCategory.map((sCat) => {
              return (
                <div style={{ margin: "10px 20px" }} key={sCat.identifier}>
                  <span onClick={() => handleChip(sCat.identifier)} className={`sub__tabs chip${sCat.identifier === activeChip ? "-active" : ""}`}>
                    {sCat.title}
                  </span>
                </div>
              );
            })}
          </div>
        );
      })}
    </DropdownButton>
  );
};

SimpleDropdownMenu.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
  handleChip: PropTypes.func,
  activeChip: PropTypes.string,
};

const SortByList = [
  {
    identifier: "Sort By:",
    name: "",
  },
  {
    identifier: "low_high",
    name: "Price: Low to High",
  },
  {
    identifier: "high_low",
    name: "Price: High to low",
  },
  {
    identifier: "new_product",
    name: "New Products",
  },
  {
    identifier: "most_popular",
    name: "Most Popular",
  },
];

const selectableChips = [
  {
    identifier: "all_spices",
    title: "Masalas (Spices)",
    subCategory: [
      {
        identifier: "classic_range",
        title: "Classic Range",
      },
      {
        identifier: "mini_packs",
        title: "Mini Pouches",
      },
      {
        identifier: "specialities",
        title: "Specialities",
      },
    ],
  },
  {
    identifier: "puja_materials",
    title: "Puja materials",
    subCategory: [],
  },
  {
    identifier: "misc",
    title: "Other Products",
    subCategory: [],
  },
];

export class View extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      lastCounter: 40,
      activeChip: "all_spices",
      isSearching: true,
      activeSortBy: "default",
      activeKeyword: "",
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
    this.totalProducts = [...SpiceDetails, ...Misc, ...DhoopDetails];
    this.products = []; // Initaily
  }
  componentDidMount() {
    const { query } = this.props;
    ReactPixel.init("145006083100066");
    let filter = query;
    this.defaultItems();
    this.handleFilter(filter);
    this.setState({
      activeChip: filter || "all_spices",
    });
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
        isSearching: false,
      });
    }, 0);
  }
  componentWillUnmount() {
    this.setState({
      showTrans: true,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0.1,
      },
      isSearching: true,
    });
  }
  defaultItems = () => {
    const { listItemById } = this.props;
    this.allMasala = [];
    this.classicMasala = [];
    this.miniPacks = [];
    this.specialities = [];
    this.pujaMaterials = [];
    this.miscItems = [];
    let uniquiIds = [];
    let miniUn = [];
    let splUni = [];
    let classicUni = [];
    let allMasalaUni = [];

    console.log(listItemById);
    Object.keys(listItemById).map((key) => {
      let item = listItemById[key];
      if (uniquiIds.indexOf(item.u_id) < 0) {
        if (listItemById[key].type === "Spices") {
          if (listItemById[key].packType === 0 && miniUn.indexOf(item.u_id) < 0) {
            miniUn.push(item.u_id);
            this.miniPacks.push(listItemById[key]);
            // this.allMasala.push(listItemById[key])
          } else if ((listItemById[key].packType === 1 || listItemById[key].packType === 2) && classicUni.indexOf(item.u_id) < 0) {
            classicUni.push(item.u_id);
            this.classicMasala.push(listItemById[key]);
            // this.allMasala.push(listItemById[key])
          }
          if (listItemById[key].spl === 1 && splUni.indexOf(item.u_id) < 0) {
            this.specialities.push(listItemById[key]);
            splUni.push(item.u_id);
          }
          if (allMasalaUni.indexOf(item.u_id) < 0) {
            allMasalaUni.push(item.u_id);
            this.allMasala.push(item);
          }
        } else if (listItemById[key].type === "Dhoop") {
          this.pujaMaterials.push(listItemById[key]);
          uniquiIds.push(item.u_id);
        } else if (listItemById[key].type === "Misc") {
          // console.log("listItemById[key]", listItemById[key])
          uniquiIds.push(item.u_id);
          this.miscItems.push(listItemById[key]);
        }
      }
    });
  };
  handleFilter = (identifier) => {
    if (!identifier || identifier === "all_spices") {
      this.products = [...this.allMasala];
    } else if (identifier === "classic_range") {
      console.log("here" + "classic range");
      this.products = [...this.classicMasala];
    } else if (identifier === "mini_packs") {
      this.products = [...this.miniPacks];
      console.log("here" + "minipack");
    } else if (identifier === "specialities") {
      this.products = [...this.specialities];
      console.log("here" + "specialities");
    } else if (identifier === "puja_materials") {
      this.products = [...this.pujaMaterials];
      console.log("here" + "Puja material");
    } else if (identifier === "misc") {
      this.products = [...this.miscItems];
      console.log("here" + "misc");
    }
    // if (this.state.activeSortBy !== "default") {
    // 	this.handleSortBy(this.state.activeSortBy, identifier)
    // }
  };
  handleChip = (identifier) => {
    // pushInUrl(identifier)
    this.setState({
      isSearching: true,
      activeChip: identifier,
      activeKeyword: "",
    });
    this.handleFilter(identifier);
    // this.products = []
    this.refs.search__by.value = null;
    setTimeout(() => {
      this.setState({
        isSearching: false,
        activeSortBy: "default",
      });
    }, 1000);
  };
  handleSortBy = (identifier, filterIdentifier) => {
    const { activeChip } = this.state;
    this.setState({
      isSearching: true,
    });
    let actuallSelectedChip = filterIdentifier || activeChip;
    let prevProductList = [...this.products];
    this.products = [];
    // let arr = actuallSelectedChip === "puja_materials" ? this.puja_materials
    // 	: actuallSelectedChip === "all_spices" ? this.allMasala
    // 		: actuallSelectedChip === "classic_range" ? this.classicMasala
    // 			: actuallSelectedChip === "specialiaties" ? this.specialiaties
    // 				: actuallSelectedChip === "miniPacks" ? this.miniPacks : []
    if (identifier === "default") {
      this.defaultItems();
      this.products = [...prevProductList];
      // return
    } else if (identifier === "low_high") {
      []
        .concat(prevProductList)
        .sort((a, b) => a.mrp - b.mrp)
        .forEach((item, i) => this.products.push(item));
    } else if (identifier === "high_low") {
      []
        .concat(prevProductList)
        .sort((a, b) => b.mrp - a.mrp)
        .forEach((item, i) => this.products.push(item));
    } else if (identifier === "most_popular") {
      if (actuallSelectedChip === "Spices") {
        []
          .concat(prevProductList)
          .sort((a, b) => a.packType - b.packType)
          .forEach((item, i) => this.products.push(item));
      } else {
        []
          .concat(prevProductList)
          .sort((a, b) => a.spl - b.spl)
          .forEach((item, i) => this.products.push(item));
        // this.products = this.specialiaties
      }
    } else if (identifier === "new_product") {
      if (actuallSelectedChip === "puja_materials" || actuallSelectedChip === "misc") {
        []
          .concat(prevProductList)
          .sort(
            (a, b) =>
              b.productName
                .toLowerCase()
                .trim()
                .search("mala") -
              a.productName
                .toLowerCase()
                .trim()
                .search("mala")
          )
          .forEach((item, i) => this.products.push(item));
      } else {
        []
          .concat(prevProductList)
          .sort((a, b) => b.packType - a.packType)
          .forEach((item, i) => this.products.push(item));
        // this.products = this.miniPacks
      }
    }
    this.setState({
      activeSortBy: identifier,
    });
    setTimeout(() => {
      this.setState({
        isSearching: false,
      });
    }, 1000);
  };
  handleSearch = (e) => {
    // e.preventdefault
    const { activeChip } = this.state;
    let str = e.target.value.length ? e.target.value.toLowerCase() : "";
    this.setState({
      isSearching: true,
      activeKeyword: str,
    });
    this.handleFilter(activeChip);
    this.handleSortBy(this.state.activeSortBy);
    let prevProductList = [...this.products];
    this.products = [];
    prevProductList.forEach((item) => {
      if (
        item.sName
          .toLowerCase()
          .trim()
          .search(str.trim()) > -1
      ) {
        this.products.push(item);
      }
    });
    setTimeout(() => {
      this.setState({
        isSearching: false,
      });
    }, 1000);
  };
  handleKeyUp = (e) => {
    // console.log("ref", e.keyCode)
    let str = e.target.value.length ? e.target.value.toLowerCase() : "";
    // setTimeout.clear()
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.timeoutId = setTimeout(() => {
      ReactPixel.track("Search", { str: str });
    }, 2000);
  };
  SeeMoreFunction = (e) => {
    this.setState({
      lastCounter: this.state.lastCounter + 20,
    });
  };
  render() {
    // const products = []
    const { activeChip, isSearching, activeSortBy, defaultStyle, lastCounter } = this.state;
    const { location, ownProps, region } = this.props;
    let title = "Sort by";
    // console.log("this.miscItems", this.miscItems)
    let selectedChipName;
    SortByList.forEach((item) => {
      if (item.identifier === activeSortBy) {
        title = item.name;
      }
    });
    selectableChips.forEach((item) => {
      if (item.identifier === activeChip) {
        selectedChipName = item.title;
      } else if (item.subCategory.length) {
        item.subCategory.forEach((sCat) => {
          if (sCat.identifier === activeChip) {
            selectedChipName = sCat.title;
          }
        });
      }
    });
    return (
      <ContentPage>
        <Meta
          title="Bawa Masala Company Store | Premium Indian Spices Since 1952"
          description="Bawa Masala Company’s whole spices, spice blends, powdered spices and speciality ingredients. Explore our full range and enquire about bulk or dealer orders."
          location={location}
        />
        <div className="global__wrapper" style={{ background: "#e9eef6" }}>
          <h1 style={{ visibility: "hidden", position: "fixed" }}>Bawa Masala Company Store | Premium Indian Spices Since 1952</h1>
          <div className="store__wrapper" style={defaultStyle}>
            <div className="store__content row">
              <div className="left___content col-md-2">
                <div className="active__chips">
                  {selectableChips.map((item) => {
                    return (
                      <div key={item.identifier} style={{ margin: "10px 0" }}>
                        <div>
                          <Link style={{ textDecoration: "none" }} to={`/store?${item.identifier}`}>
                            <span
                              onClick={() => this.handleChip(item.identifier)}
                              className={`prim__tabs chip${item.identifier === activeChip ? "-active" : ""}`}
                            >
                              {item.title}
                            </span>
                          </Link>
                        </div>
                        <div className="sub__tabs" style={{ margin: "0px 0 0px 10%" }}>
                          {item.subCategory.map((sCat) => {
                            return (
                              <div style={{ margin: "10px 0" }} key={sCat.identifier}>
                                <span
                                  onClick={() => this.handleChip(sCat.identifier)}
                                  className={`sub__tabs chip${sCat.identifier === activeChip ? "-active" : ""}`}
                                >
                                  {sCat.title}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="right__content  col-md-10">
                <div className="region_msg">
                  <i>
                    <b>
                      We currently do not ship to Delhi, U.P., Punjab, Haryana, Uttarakhand & U.T. of Chandigarh. To place an order for these states, please
                      visit{" "}
                      <a href="https://bawaindustries.com/" target="_blank" className="href">
                        www.bawaindustries.com
                      </a>
                    </b>
                  </i>
                </div>
                <div className="filter__bar">
                  <div className="row">
                    <div className="col-lg-3 col-md-3 col-xs-5">
                      <input
                        onKeyUp={this.handleKeyUp}
                        type="text"
                        ref="search__by"
                        className="search__by"
                        onChange={(e) => this.handleSearch(e)}
                        placeholder="Search by Name"
                        name="search"
                        value={this.state.activeKeyword}
                      />
                    </div>
                    <div className="col-lg-2 col-md-2 col-xs-7  pull-right">
                      <div className="sort__by  pull-right">
                        <ButtonToolbar>
                          <DropdownMenu handleSortBy={this.handleSortBy} title={title} activeSortBy={activeSortBy} items={SortByList} />
                        </ButtonToolbar>
                      </div>
                    </div>
                  </div>
                  <div className="row mobile-dropdown" style={{ marginTop: "7px" }}>
                    <ButtonToolbar>
                      <SimpleDropdownMenu handleChip={this.handleChip} title={selectedChipName} activeChip={activeChip} items={selectableChips} />
                    </ButtonToolbar>
                  </div>
                </div>
                <RestrictedStateWiseComponent regionName={region}>
                  <div className="minimum_order_strip">
                    <i>
                      <b>Free shipping on orders of Rs. 500 and above</b>
                    </i>
                  </div>
                </RestrictedStateWiseComponent>
                <div className="product__details">
                  <div className="row">
                    {isSearching ? (
                      <div style={{ margin: "10% 50% 10%" }}>
                        <ClipLoader color={"#19217a"} loading={isSearching} />
                      </div>
                    ) : this.products.length ? (
                      this.products.slice(0, lastCounter).map((item, i) => {
                        return (
                          <div key={i} className="col-lg-3 col-sm-6 col-md-4 col-xs-12" style={{ padding: "5px" }}>
                            <ProductStoreCard key={i} product={item} {...ownProps} />
                          </div>
                        );
                      })
                    ) : (
                      <div className="no__product">No Product in the list</div>
                    )}
                  </div>
                </div>
                <div className="see_more">
                  {lastCounter >= this.products.length ? null : (
                    <div className="errow_img">
                      <button className="see_more_button" onClick={() => this.SeeMoreFunction()}>
                        See More
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </ContentPage>
    );
  }
}

View.propTypes = {
  query: PropTypes.string,
  region: PropTypes.string,
};

const mapDisptchToProps = (dispatch, ownProps) => {
  // console.log("createHistory", browserHistory)
  // const { push } = browserHistory
  return {
    // pushInUrl: (filterSt) => store.dispatch(push(`store?filter=${filterSt}`)),
  };
};

const mapStateToProps = (state, ownProps) => {
  const { location } = ownProps;
  const { products } = state;
  const query = location.search.split("?")[1];
  return {
    ...ownProps,
    query: query,
    listItemById: products.listItemById || [],
    region: state.ipData.region || "delhi",
  };
};

export default connect(mapStateToProps, mapDisptchToProps)(View);



// WEBPACK FOOTER //
// ./src/pages/store/index.js